import { render, staticRenderFns } from "./EventDetailsDialog.vue?vue&type=template&id=b16a5b8c&scoped=true"
import script from "./EventDetailsDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsDialog.vue?vue&type=style&index=0&id=b16a5b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a5b8c",
  null
  
)

export default component.exports